module.exports = __webpack_public_path__ + "img/0030.f52e6896.png";